import React from 'react'
import * as FaIcons from 'react-icons/fa'
import { FaRegCalendarCheck } from 'react-icons/fa'
// import { GiExitDoor } from "react-icons/gi";

export const SidebarData = [
    {
        title: 'Dashboard',
        path: '/home',
        icon: <FaIcons.FaHome />,
        text: 'dashboard'
    },
    {
        title: 'People',
        path: '/people',
        icon: <FaIcons.FaUsers />,
        text: 'people'

    },
    {
        title: 'Leave & Attendance',
        path: '/leaveAttendance',
        icon: <FaIcons.FaTasks />,
        text: 'attendanceLeave'
    },
    {
        title: 'Leave Approval & Apply',
        path: '/leave-approval',
        icon: <FaIcons.FaCheckCircle />,
        text: 'leaveApproval'
    },
    {
        title: 'Salary Slips',
        path: '/salarySlip',
        icon: <FaIcons.FaMoneyBillWave />,
        text: 'salarySlip'

    },
    {
        title: 'Guest User',
        path: '/guestUser',
        icon: <FaIcons.FaMoneyBillWave />,
        text: 'guestUser'

    },
    {
        title: 'Interview Process',
        path: '/interviewProcess',
        icon: <FaIcons.FaMoneyBillWave />,
        text: 'interview'

    },
    {
        title: 'Attendance Details',
        path: '/attendanceDetails',
        icon: <FaRegCalendarCheck />,
        text: 'attendanceDetails'

    },
    {
        title: 'Run Payroll',
        path: '/runpayroll',
        icon: <FaIcons.FaRegMoneyBillAlt />,
        text: 'runPayroll'
    },
    {
        title: 'Documents',
        path: '/documents',
        icon: <FaIcons.FaPassport />,
        text: 'documents'

    },
    {
        title: 'Reimbursement',
        path: '/reimbursement',
        icon: <FaIcons.FaMoneyCheck />,
        text: 'reimbursement'

    },
    {
        title: 'Employee History',
        path: '/payablematrix',
        icon: <FaIcons.FaMoneyCheck />,
        text: 'payablematrix'

    },
    {
        title: 'Matrix Details',
        path: '/matrix',
        icon: <FaIcons.FaTable />,
        text: 'matrix'
    },
    {
        title: 'Designation',
        path: '/designation',
        icon: <FaIcons.FaCriticalRole />,
        text: 'designation'

    },
    {
        title: 'Leave Balance',
        path: '/leave-balance',
        icon: <FaIcons.FaUserCheck />,
        text: 'leavebalance'
    },

    {
        title: 'Reports',
        path: '/reports',
        icon: <FaIcons.FaPrint />,
        text: 'report'

    },

    {
        title: 'Setting',
        path: '/setting',
        icon: <FaIcons.FaScrewdriver />,
        text: 'setting'
    }
]
